exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.alinhamento[data-v-f41c74c0]{-webkit-box-align:left;-ms-flex-align:left;align-items:left;text-align:left\n}\n.recuo-texto[data-v-f41c74c0]{text-indent:1em\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/AppDisplayColapse.vue"],"names":[],"mappings":";AA+DA,8BACE,uBAAA,oBAAA,iBACA,eAAgB;CACjB;AAAA,8BAGC,eACF;CAAC","file":"AppDisplayColapse.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.alinhamento {\n  align-items: left;\n  text-align: left;\n}\n\n.recuo-texto {\n  text-indent:1em\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f41c74c0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppDisplayColapse.vue
// module id = UDwA
// module chunks = 11